<template>
    <div>
        <h1 v-if="error && error.status === 404">{{ title }} {{ $t("doesn't exist") }}</h1>
        <h1 v-else-if="error && error.status === 403">{{ $t('Access denied for ') }} {{ title }}</h1>
        <h1 v-else-if="error && error.status === 500">{{ $t('There was an error. Please contact support (Error 500).') }}</h1>
        <h1 v-else>{{ $t('There was an error') }}</h1>
    </div>
</template>

<script>


    export default {
        props: [
            'error',
            'title'
        ],
    }
</script>
